export default "<figure>\n    <div>\n      <img src=\"../../../assets/images/okay-1s-347px.svg\">\n    </div>\n  </figure>"